import _slicedToArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    margin: 10px 0;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    margin-left: 10px;\n    transform: rotate(", "deg);\n    ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    padding: 0;\n    &:hover,\n    &:focus,\n    &:active {\n        text-decoration: none;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { cloneElement, useCallback, useState, forwardRef } from 'react';
import styled from 'styled-components';
import { Button } from '../Button';
import { Balloon } from '../Balloon';
import { List } from '../List';
import { ArrowDownIcon } from '../icons';
import { transitions } from '../mixins';
var OFFSET_X = 14;
var StyledButton = styled(Button)(_templateObject());
var StyledArrowDownIcon = styled(ArrowDownIcon)(_templateObject2(), function (_ref) {
  var flipped = _ref.flipped;
  return flipped ? -180 : 0;
}, transitions(['transform']).easeOut().standard());
var ActionList = styled(List)(_templateObject3());
export var ActionListButton = forwardRef(function (_a, ref) {
  var strings = _a.strings,
      _a$showArrow = _a.showArrow,
      showArrow = _a$showArrow === void 0 ? false : _a$showArrow,
      onClick = _a.onClick,
      children = _a.children,
      props = __rest(_a, ["strings", "showArrow", "onClick", "children"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpenActions = _useState2[0],
      setIsOpenActions = _useState2[1];

  var handleClickBtn = useCallback(function () {
    var newValue = !isOpenActions;

    if (onClick) {
      onClick({
        value: newValue
      });
    }

    setIsOpenActions(newValue);
  }, [isOpenActions, onClick]);
  var renderActionList = React.createElement(ActionList, null, React.Children.map(children, function (item, index) {
    if (!item) {
      return item;
    }

    var onClick = item.props.onClick;
    return cloneElement(item, {
      onClick: useCallback(function (event) {
        setIsOpenActions(false);

        if (onClick) {
          onClick(event);
        }
      }, [onClick, setIsOpenActions]),
      key: index
    });
  }));
  var modifiers = showArrow ? {
    arrow: {
      fn: function fn(data) {
        return Object.assign(Object.assign({}, data), {
          arrowStyles: {
            right: "".concat(OFFSET_X / 2, "px")
          }
        });
      }
    }
  } : {};
  return React.createElement(Balloon, {
    content: renderActionList,
    opened: isOpenActions,
    placement: 'bottom-end',
    offsetY: 10,
    offsetX: showArrow ? OFFSET_X : 0,
    modifiers: modifiers,
    onOutsideClick: function onOutsideClick() {
      return setIsOpenActions(false);
    }
  }, React.createElement(StyledButton, Object.assign({
    ref: ref,
    variant: 'text',
    onClick: handleClickBtn
  }, props), strings.button, showArrow && React.createElement(StyledArrowDownIcon, {
    flipped: isOpenActions,
    width: 12,
    height: 12
  })));
});
ActionListButton.displayName = 'ActionListButton';